import { Theme } from '@mui/material/styles';
import { palette } from 'src/theme/palette';
import { typographyBase } from 'src/theme/typography';

const getHeaderHeightStyle = ({ theme, loading }: { loading: boolean; theme: Theme }) => {
  return loading ? '0 !important' : `${theme.spacing(42)} !important`;
};

export const muiDataGridHeadersStyleOverride = ({
  theme,
  loading,
}: {
  loading: boolean;
  theme: Theme;
}) => ({
  height: getHeaderHeightStyle({ theme, loading }),
  minHeight: getHeaderHeightStyle({ theme, loading }),
  maxHeight: `${theme.spacing(42)} !important`,
  lineHeight: getHeaderHeightStyle({ theme, loading }),
  position: 'sticky',
  top: 0,

  '& .MuiDataGrid-columnHeader': {
    ...typographyBase.text3,
    borderRadius: 0,
    height: getHeaderHeightStyle({ theme, loading }),

    borderBottom: '1px solid #dfdfdf',
    '&:focus': {
      outline: 'none',
    },
    '&:focus-within': {
      outline: 'none',
    },
  },

  '& .MuiDataGrid-columnHeader--pinnedRight': {
    backgroundColor: 'transparent',
    borderLeft: 'none',
    '& *': {
      opacity: '0 !important',
    },
    '& .MuiDataGrid-columnHeader': {
      opacity: '0 !important',
    },
  },

  '& .MuiDataGrid-columnHeader--pinnedLeft': {
    borderRight: 'none',
  },

  '&:hover': {
    '& .MuiDataGrid-columnHeader--pinnedRight:not(:has(.MuiDataGrid-columnHeaderTitle:empty))': {
      backgroundColor: palette.DataGrid.headerBg,
      '& *': {
        opacity: '1 !important',
      },
      '& .MuiDataGrid-columnHeader': {
        opacity: '1 !important',
      },
    },
    '& .MuiDataGrid-columnSeparator': {
      opacity: 1,
    },
  },
});
